import React from 'react';

export default function Code({children}) {
  return (
    <pre className="rounded bg-light p-2 p-md-3" style={{wordBreak: 'break-all', whiteSpace: 'normal'}}>
      {children}
    </pre>
  );
}
